import withFormUtils from "./withFormUtils";

export default {
  mixins: [withFormUtils],

  destroyed() {
    this.clearForm();
    this.setFormTouchedValue();
  }
};
